import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Button } from '@driftt/tide-core'
import { Div } from '@driftt/tide-core'

import { fetchInsightById } from 'api'
import { CurrentUserContext } from 'context/currentUserContext'
import useBreadcrumb from 'hooks/useBreadcrumb'
import { SessionMetrics } from 'hooks/useSessionMetrics'
import { Insight } from 'modules/accountActivity/domain'
import { rootPath } from 'utils/paths'
import { segmentTrack, TrackType } from 'utils/tracking'

import CCRMFeedCard from '../FeedCard'

import styles from './styles.module.css'

interface InsightCardProps {
  sessionMetrics: SessionMetrics
}

const InsightCard: React.FC<InsightCardProps> = ({ sessionMetrics }) => {
  const params = useParams<{ insightId: string }>()
  const [insight, setInsight] = useState<Insight>()
  const { navigateTo } = useBreadcrumb()

  const currentUser = useContext(CurrentUserContext)

  useEffect(() => {
    const callback = async () => {
      try {
        const { data } = await fetchInsightById(params.insightId)
        setInsight(data)
        segmentTrack(TrackType.INSIGHT_CARD_PAGE_OPENED, {
          userId: currentUser?.id,
          email: currentUser?.email,
          orgId: currentUser?.orgId,
          role: currentUser?.roles,
          insight: insight?.id
        })
      } catch (error) {
        console.log(error) // eslint-disable-line no-console
      }
    }
    callback()
  }, []) // eslint-disable-line

  const handleBackButtonOnClick = () => {
    segmentTrack(TrackType.BACK_TO_FEED_FROM_INSIGHT_CARD_PAGE, {
      userId: currentUser?.id,
      email: currentUser?.email,
      orgId: currentUser?.orgId,
      role: currentUser?.roles,
      event: `BACK_TO_ACTIVITY_FEED_CLICKED FROM ${insight?.insightType}`,
      insight: insight?.id
    })

    navigateTo(rootPath)
  }

  return (
    <Div className={styles.container}>
      <div className={styles.insightCard}>
        {insight && (
          <div className={styles.ccrmFeedCard}>
            <div className={styles.backButton}>
              <Button
                onClick={handleBackButtonOnClick}
                className={styles.backButton}
                type="utility"
                icon="arrow-1-left">
                Back to Account Activity
              </Button>
            </div>
            <div className={styles.cardContainer}>
              <CCRMFeedCard
                key={params.insightId}
                insight={insight}
                countCardDwellTime={sessionMetrics.countCardDwellTime}
                commentsInitiallyOpen={true}
              />
            </div>
          </div>
        )}
      </div>
    </Div>
  )
}

export default InsightCard
